import { ProjectAssets, ImageAssets, VideoAssets, DownloadAssets } from '@models';
import * as Title_01 from './Title_01.png'
import * as Image_01 from './Image_01.png'
import * as Video_01 from './Video_01.mp4';

export const Title: ImageAssets = {
    Title_01
};

export const Images: ImageAssets = {
    Image_01
};

export const Videos: VideoAssets = {
    Video_01
};

export const Downloads: DownloadAssets = {
    
};

const AbscissionOfLight: ProjectAssets = {
    Title,
    Images,
    Videos,
    Downloads
};

export default AbscissionOfLight;